import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { FONT } from "@/lib/tokens";
import { appleEase } from "@/lib/motion";

/* ─────────────────────────────────────────────────────
   SECTION 4 — grille 2×2 (équivalent mainpage4)
   4 tuiles côte à côte, 2 par ligne.
───────────────────────────────────────────────────── */
const CSS = `
  .tg-grid {
    background-color: #FFFFFF;
    display: flex;
    flex-wrap: wrap;
  }

  .tg-tile {
    flex-basis: calc(50% - 10px);
    margin: 5px;
    background-size: cover;
    background-position: center top;
    background-repeat: no-repeat;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: hidden;
  }

  /* Tile A — Pour les entreprises */
  .tg-tile-a {
    background-color: #F5F5F7;
    color: #1D1D1F;
    justify-content: flex-start;
    height: auto;
    min-height: 580px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0;
  }

  .tg-tile-a-text {
    padding: 48px 24px 0;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 10;
  }

  .tg-tile-a-visual {
    margin-top: 32px;
    padding-bottom: 32px;
    box-sizing: border-box;
    width: 100%;
    flex-grow: 1;
    display: flex;
    align-items: flex-end;
    justify-content: center;
  }

  .tg-tile-a-visual img {
    width: 100%;
    height: auto;
    display: block;
  }

  /* Core Engine widget (Tile A visual) */
  .core-engine {
    position: relative;
    overflow: hidden;
    border-radius: 28px;
    padding: 44px 44px 40px;
    width: 100%;
    max-width: 460px;
    box-sizing: border-box;
    font-family: "Albert Sans", -apple-system, sans-serif;
    background: radial-gradient(120% 90% at 20% 0%, #ffffff 0%, #fbfbfc 55%, #f7f7f8 100%);
    border: 1px solid rgba(0,0,0,.06);
    box-shadow: 0 30px 80px -30px rgba(0,0,0,.16), 0 2px 10px rgba(0,0,0,.05);
  }

  .ce-glow { position: absolute; border-radius: 50%; pointer-events: none; animation: ce-breath 6s ease-in-out infinite; }
  .ce-glow--blue  { top: -40%; left: 8%; width: 420px; height: 420px; background: radial-gradient(circle, rgba(41,151,255,.14) 0%, rgba(41,151,255,0) 70%); }
  .ce-glow--green { bottom: -30%; right: 2%; width: 360px; height: 360px; background: radial-gradient(circle, rgba(26,140,74,.12) 0%, rgba(26,140,74,0) 70%); animation-duration: 7s; }

  .ce-header { position: relative; display: flex; align-items: center; justify-content: space-between; margin-bottom: 38px; }
  .ce-title { display: flex; align-items: center; gap: 12px; color: #1D1D1F; font-size: 16px; font-weight: 600; letter-spacing: -.01em; white-space: nowrap; }
  .ce-version { color: #86868b; font-family: "JetBrains Mono", monospace; font-size: 11px; letter-spacing: .08em; }

  .ce-rows { position: relative; display: flex; flex-direction: column; gap: 26px; }
  .ce-row { display: flex; align-items: center; gap: 20px; }
  .ce-label { width: 132px; flex-shrink: 0; color: #3a3a3c; font-size: 14px; font-weight: 500; letter-spacing: -.01em; }
  .ce-track { position: relative; flex: 1; height: 2px; border-radius: 2px; background: rgba(0,0,0,.08); }
  .ce-fill { position: absolute; top: 0; left: 0; height: 100%; border-radius: 2px; background: linear-gradient(90deg, rgba(41,151,255,.3), rgba(0,0,0,.55)); }
  .ce-flow { position: absolute; top: 0; left: 0; height: 100%; width: 40px; border-radius: 2px; background: linear-gradient(90deg, transparent, rgba(41,151,255,.9)); animation: ce-flow 4.2s cubic-bezier(.28,.11,.32,1) infinite; }
  .ce-node { position: absolute; top: 50%; width: 9px; height: 9px; margin: -4.5px 0 0 -4.5px; border-radius: 50%; background: #1a8c4a; animation: ce-node 3s ease-in-out infinite; }

  .ce-footer { position: relative; margin-top: 40px; padding-top: 26px; border-top: 1px solid rgba(0,0,0,.08); display: flex; align-items: center; justify-content: space-between; }
  .ce-status-label { color: #86868b; font-size: 17.5px; font-weight: 600; letter-spacing: -0.01em; text-transform: none; }
  .ce-status { display: flex; align-items: center; gap: 9px; color: #1D1D1F; font-size: 14px; font-weight: 600; letter-spacing: -.01em; }

  .ce-dot { width: 7px; height: 7px; border-radius: 50%; background: #1a8c4a; }
  .ce-dot--status { width: 9px; height: 9px; animation: ce-status 2.4s ease-in-out infinite; }
  .ce-dot--op { box-shadow: 0 0 10px 1px rgba(26,140,74,.7); }

  @keyframes ce-node {
    0%, 100% { box-shadow: 0 0 0 0 rgba(26,140,74,.55), 0 0 14px 2px rgba(26,140,74,.65); }
    50%      { box-shadow: 0 0 0 6px rgba(26,140,74,0), 0 0 20px 4px rgba(26,140,74,.85); }
  }
  @keyframes ce-flow {
    0%   { transform: translateX(-120%); opacity: 0; }
    35%  { opacity: 1; }
    100% { transform: translateX(320%); opacity: 0; }
  }
  @keyframes ce-status {
    0%, 100% { opacity: .55; transform: scale(1); }
    50%      { opacity: 1; transform: scale(1.25); }
  }
  @keyframes ce-breath {
    0%, 100% { opacity: .5; }
    50%      { opacity: .85; }
  }

  @media (max-width: 480px) {
    .core-engine { padding: 32px 24px 28px; }
    .ce-label { width: 112px; font-size: 13px; }
  }

  /* Tile B — Manifesto */
  .tg-tile-b {
    background-color: #F5F5F0;
    color: #1D1D1F;
    position: relative;
    overflow: hidden;
    height: auto;
    min-height: 580px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0;
    box-sizing: border-box;
  }

  .tg-tile-b-text {
    padding: 48px 24px 0;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 10;
  }

  .tg-tile-b-visual {
    margin-top: 32px;
    width: 100%;
    flex-grow: 1;
    position: relative;
  }

  .tg-tile-b-visual::after {
    content: '';
    position: absolute;
    top: 0; left: 0; right: 0;
    height: 120px;
    background: linear-gradient(to bottom, #F5F5F0 0%, transparent 100%);
    pointer-events: none;
    z-index: 2;
  }

  .tg-tile-b-visual img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center 20%;
    display: block;
  }

  /* Tile C — Structure Apple-like Premium */
  .tg-tile-c {
    background-color: #000000;
    color: #F5F5F7;
    position: relative;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    padding: 0;
    box-sizing: border-box;
    text-align: center;
    height: auto;
    min-height: 580px;
  }

  .tg-tile-c-top {
    padding: 44px 24px 0;
    z-index: 10;
    position: relative;
  }

  .tg-tile-c-visual {
    flex-grow: 1;
    position: relative;
    width: 100%;
    margin-top: -10px;
  }

  .tg-tile-c-visual::after {
    content: '';
    position: absolute;
    top: 0; left: 0; right: 0;
    height: 140px;
    background: linear-gradient(to bottom, #000000 0%, transparent 100%);
    pointer-events: none;
    z-index: 2;
  }

  .tg-tile-c-visual img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center bottom;
    display: block;
  }

  /* Tile D — Invitation Bâtisseur */
  .tg-tile-d {
    background: linear-gradient(135deg, #1A1A1C 0%, #111113 65%, #151518 100%);
    border-left: 1px solid rgba(93, 123, 147, 0.3);
    padding: 64px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    box-sizing: border-box;
    text-align: left;
    height: auto;
    min-height: 580px;
    position: relative;
  }

  .tg-tile-d-inner {
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .tg-tile-d-surtitre {
    font-size: 17.5px;
    letter-spacing: -0.01em;
    font-weight: 600;
    color: #FF6B00;
    text-transform: none;
    margin-bottom: 24px;
    font-family: ${FONT};
  }

  .tg-tile-d-titre {
    font-size: clamp(1.8rem, 4vw, 2.6rem);
    font-weight: 700;
    color: #F5F5F7;
    letter-spacing: -0.02em;
    line-height: 1.15;
    margin-bottom: 24px;
    font-family: ${FONT};
  }

  .tg-tile-d-hr {
    width: 40px;
    height: 1px;
    background: #FF6B00;
    margin-bottom: 32px;
    border: none;
  }

  .tg-tile-d-para {
    font-size: 1rem;
    color: rgba(245,245,247,0.55);
    line-height: 1.75;
    max-width: 420px;
    margin-bottom: 48px;
    font-family: ${FONT};
  }

  .tg-tile-d-highlight {
    color: #FF6B00;
    font-weight: 700;
  }

  .tg-btn-founder-black {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 48px;
    padding: 0 32px;
    background: #0A0A0A;
    color: #FFFFFF;
    border: 1.5px solid #FFFFFF;
    border-radius: 999px;
    font-size: 15px;
    font-weight: 600;
    text-decoration: none;
    transition: all 0.2s ease;
  }

  .tg-btn-founder-black:hover {
    background: #FFFFFF;
    color: #0A0A0A;
    box-shadow: 0 12px 28px -6px rgba(255,255,255,0.35);
  }

  .tg-tile-d-stack {
    display: flex;
    flex-direction: row;
    gap: 28px;
    align-items: center;
    flex-wrap: wrap;
  }

  /* Labels */
  .tg-tile-label {
    margin-top: 10px;
    font-size: 17.5px;
    font-weight: 600;
    font-family: ${FONT};
    letter-spacing: -0.01em;
    text-transform: none;
  }

  .tg-tile-label.black  { color: #000000; }
  .tg-tile-label.orange { color: #E65100; }

  /* Titles */
  .tg-tile-title {
    margin-top: 12px;
    font-size: clamp(24px, 5vw, 32px);
    font-weight: 700;
    letter-spacing: -0.032em;
    line-height: 1.14;
    font-family: ${FONT};
    max-width: 420px;
  }

  .tg-tile-title.dark  { color: #1D1D1F; }

  /* Subs */
  .tg-tile-sub {
    margin-top: 12px;
    font-size: clamp(15px, 3vw, 17px);
    font-family: ${FONT};
    letter-spacing: -0.01em;
    line-height: 1.5;
    max-width: 380px;
  }

  .tg-tile-sub.muted { color: #1D1D1F; }

  /* Big lines for tile C */
  .tg-tile-line {
    font-family: ${FONT};
    font-weight: 700;
    letter-spacing: -0.038em;
    line-height: 1.14;
    margin: 0;
    font-size: clamp(24px, 5vw, 32px);
  }

  .tg-tile-line-1 { color: #F5F5F7; margin-top: 10px; }
  .tg-tile-line-2 { color: rgba(255,255,255,0.60); margin-top: 4px; }
  .tg-tile-line-3 { color: rgba(255,255,255,0.35); margin-top: 4px; }

  /* Links */
  .tg-btn-pill, .tg-btn-white-pill, .tg-btn-pill-secondary {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 44px;
    padding: 0 24px;
    border-radius: 999px;
    font-size: 15px;
    font-weight: 500;
    text-decoration: none;
    transition: all 0.2s ease;
  }

  .tg-btn-pill { background-color: #1D5FD1; color: #FFFFFF !important; }
  .tg-btn-white-pill { background-color: transparent; color: #FFFFFF !important; border: 1px solid #1D5FD1; }
  .tg-btn-pill-secondary { background-color: transparent; color: #1D5FD1 !important; border: 1px solid #1D5FD1; }

  /* Responsive */
  @media (max-width: 1024px) {
    .tg-tile { flex-basis: calc(50% - 10px); }
  }

  @media (max-width: 768px) {
    /* Bandes de séparation fines et régulières (5px) entre les 4 cards :
       le fond blanc de la grille est visible via le gap + le padding, et les
       marges des tuiles passent à 0. Mobile uniquement. */
    .tg-grid { gap: 5px; padding: 5px 0; }
    .tg-tile { flex-basis: 100%; margin: 0; min-height: 520px; }
    .tg-tile-d { padding: 48px 32px; min-height: auto; }
    .tg-tile-a-text, .tg-tile-b-text { padding-top: 40px; }
    .tg-tile-c-top { padding-top: 40px; }
    /* Le widget "Core Engine" ne touche plus les bords de l'écran : marges
       latérales pour qu'il respire sur mobile. */
    .tg-tile-a-visual { padding-left: 24px; padding-right: 24px; }
    .tg-tile-d-stack { flex-direction: column; align-items: stretch; gap: 16px; }
    .tg-btn-founder-black { width: 100%; }
  }
`;

const CORE_ENGINE_ROWS = [
  { label: "Savoir-faire",   fill: 90, flowDelay: "0s",   nodeDelay: "0s" },
  { label: "Traitement IA",  fill: 78, flowDelay: ".6s",  nodeDelay: ".5s" },
  { label: "Automatisation", fill: 85, flowDelay: "1.2s", nodeDelay: "1s" },
  { label: "Distribution",   fill: 70, flowDelay: "1.8s", nodeDelay: "1.5s" },
  { label: "Croissance",     fill: 62, flowDelay: "2.4s", nodeDelay: "2s" },
];

function CoreEngineWidget() {
  return (
    <div className="core-engine">
      <div className="ce-glow ce-glow--blue" />
      <div className="ce-glow ce-glow--green" />

      <div className="ce-header">
        <div className="ce-title">
          <span className="ce-dot ce-dot--status" />
          <span>Actif stratégique</span>
        </div>
        <span className="ce-version">v2.4</span>
      </div>

      <div className="ce-rows">
        {CORE_ENGINE_ROWS.map((row) => (
          <div className="ce-row" key={row.label}>
            <div className="ce-label">{row.label}</div>
            <div className="ce-track">
              <div className="ce-fill" style={{ width: `${row.fill}%` }} />
              <div className="ce-flow" style={{ animationDelay: row.flowDelay }} />
              <div className="ce-node" style={{ left: `${row.fill}%`, animationDelay: row.nodeDelay }} />
            </div>
          </div>
        ))}
      </div>

      <div className="ce-footer">
        <span className="ce-status-label">État du système</span>
        <div className="ce-status">
          <span className="ce-dot ce-dot--op" />
          <span>Opérationnel</span>
        </div>
      </div>
    </div>
  );
}

export default function PromoSection() {
  return (
    <section>
      <style>{CSS}</style>
      <div className="tg-grid">

        {/* ── Tile A — Pour les entreprises ── */}
        <motion.div
          className="tg-tile tg-tile-a"
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.7, ease: appleEase }}
        >
          <div className="tg-tile-a-text">
            <p className="tg-tile-title dark">
              Des systèmes conçus pour produire.
            </p>
            <p className="tg-tile-sub muted">
              Chaque actif répond à un objectif concret : gagner du temps, générer des clients, structurer une activité ou accélérer une croissance.
            </p>
            <div className="tg-tile-links" style={{ marginTop: "18px" }}>
              <Link to="/marketplace" className="tg-btn-pill-secondary">Explorer les actifs</Link>
            </div>
          </div>
          <div className="tg-tile-a-visual">
            <CoreEngineWidget />
          </div>
        </motion.div>

        {/* ── Tile B — Manifesto ── */}
        <motion.div
          className="tg-tile tg-tile-b"
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.7, ease: appleEase, delay: 0.1 }}
        >
          <div className="tg-tile-b-text">
            <span className="tg-tile-label black">Notre vision</span>
            <p className="tg-tile-title dark" style={{ marginTop: 16 }}>
              Le futur du travail n'est pas la prestation. C'est l'actif.
            </p>
            <p className="tg-tile-sub muted" style={{ marginTop: 16, marginBottom: 0 }}>
              Les experts ne vendront plus leur temps.<br />
              Ils vendront des systèmes.
            </p>
            <div className="tg-tile-links" style={{ marginTop: 24 }}>
              <Link to="/devenir-createur" className="tg-btn-pill">Rejoindre Tangig</Link>
            </div>
          </div>

          <div className="tg-tile-b-visual">
            <img src="/images/notre-vision-v5.webp" alt="Notre vision" />
          </div>
        </motion.div>

        {/* ── Tile C — Structure Apple ── */}
        <motion.div
          className="tg-tile tg-tile-c"
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.7, ease: appleEase, delay: 0.05 }}
        >
          <div className="tg-tile-c-top">
            <p className="tg-tile-line tg-tile-line-1" style={{ marginTop: 0 }}>Créez une fois.</p>
            <p className="tg-tile-line tg-tile-line-2">Diffusez partout.</p>
            <p className="tg-tile-line tg-tile-line-3">Gagnez en continu.</p>

            <div className="tg-tile-links" style={{ marginTop: "24px", alignItems: "center" }}>
              <Link to="/marketplace" className="tg-btn-white-pill">Explorer les actifs</Link>
            </div>
          </div>

          <div className="tg-tile-c-visual">
            <img
              src="/images/tangig-createur.jpeg"
              alt="Tangig creator"
            />
          </div>
        </motion.div>

        {/* ── Tile D — Invitation Bâtisseur ── */}
        <motion.div
          className="tg-tile tg-tile-d"
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.7, ease: appleEase, delay: 0.15 }}
        >
          <div className="tg-tile-d-inner">
            <span className="tg-tile-d-surtitre">LE STANDARD</span>

            <h3 className="tg-tile-d-titre">
              Construisez l'avenir.<br />Pas une activité fragile.
            </h3>

            <div className="tg-tile-d-hr" />

            <p className="tg-tile-d-para">
              TANGIG n’est pas une plateforme freelance de plus.<br />
              C’est une infrastructure pensée pour les indépendants qui veulent posséder leurs systèmes, leurs revenus et leur distribution.<br /><br />
              <span className="tg-tile-d-highlight">Ceux qui commencent maintenant construiront le marché.</span>
            </p>

            <div className="tg-tile-d-stack" style={{ marginTop: '32px' }}>
              <Link to="/devenir-createur" className="tg-btn-founder-black">
                Devenir membre fondateur
              </Link>
            </div>

          </div>
        </motion.div>

      </div>
    </section>
  );
}